import { StatusTag } from "@/molecules/StatusTag"

import type { StatusTagCellComponent } from "."

export const StatusTagCell: StatusTagCellComponent = (t) =>
  function StatusesTagCellComponent(value) {
    const { tKey, status } = value

    return <StatusTag status={status} text={t(tKey)} />
  }
